import React, {Fragment, useContext, useEffect} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getUsersRouterLink} from "root/Wieldy/routePaths";
import { UserTypeFilters} from "root/DataFunctions/Constants";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import AdminModuleContext from "../AdminModuleContext";

const AdminOrganisationSubmenu = (props ) =>
{
    // The organisation Context renders the add/edit organisation modal so we don't have to render it twice
    const organisations = useContext(AdminModuleContext) ;

    return (
        <Fragment key='ky'>
            <AppSidebarGroup key='sbg' title='Filters' default={UserTypeFilters.STAFF}>
                <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.STAFF)} title='Staff' iconName='icon-user-o' name={UserTypeFilters.STAFF}/>
            </AppSidebarGroup>

            <WieldySidebarSection key='sbs' title='New Organisation' >
                <WieldySidebarClick modal={() => organisations.activateOrganisationModal( null, 'create')} title='Organisation' iconName='icon-add-circle' iconSize='icon-xl' keyName='ocb' key='ocn'/>
            </WieldySidebarSection>
        </Fragment>
    )
}

export default AdminOrganisationSubmenu ;